export const YEAR = 'YEAR';
export const MONTH = 'MONTH';
export const WEEK = 'WEEK';
export const HOUR = 'HOUR';
export const BIWEEKLY = 'BIWEEKLY';
export const SEMIMONTHLY = 'SEMIMONTHLY';
